import React from 'react';
import Button from '../Button';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';

const ManageModal = ({
  children,
  title,
  subTitle,
  className = '',
  classNameContent = '',
  onCloseModal,
  onSubmit,
  cancelButton,
  sumbitButton,
  isLoading,
  isButtonDisabled = false,
  showLoadingButton,
  onBackClick,
  onRemoveItem,
  paddings = 'py-15 py-md-30 px-8 px-md-40',
  classNameForm = '',
  errorMessage = '',
}) => {
  const { t } = useTranslation();

  const onFormSubmit = e => {
    e.preventDefault();
    onSubmit && onSubmit();
  };

  return (
    <Modal
      isOpen={true}
      className={`manage-modal d-flex flex-column justify-content-between mx-8 ${paddings} ${className}`}
      onCloseModal={onCloseModal}
      onBackClick={onBackClick}
    >
      {title && (
        <h1 className={`text-center mb-12 ${onBackClick ? 'pl-15 pr-10' : ''} ${subTitle ? 'mb-md-8' : 'mb-md-15'}`}>
          {title}
        </h1>
      )}
      {subTitle && <h2 className='text-center mb-12 mb-md-15 fw-400'>{subTitle}</h2>}
      {errorMessage && (
        <div
          className='alert alert-danger'
          role='alert'
          style={{
            padding: '12px 16px',
            borderRadius: '8px',
            backgroundColor: '#fee2e2',
            border: '1px solid #fecaca',
            color: '#991b1b',
            fontSize: '14px',
            marginBottom: '16px',
            textAlign: 'left',
          }}
        >
          {errorMessage}
        </div>
      )}
      <form onSubmit={onFormSubmit} className={classNameForm}>
        <div className={`form-content ${classNameContent}`}>{isLoading ? <Loading className='my-10' /> : children}</div>
        <div className='d-flex align-items-center justify-content-center mt-8 mt-md-10 flex-wrap row'>
          <Button
            type='button'
            className={'btn-md-sm px-21 text-nowrap px-md-15 mx-8 btn-outline-primary col col-md-none'}
            onClick={onCloseModal}
          >
            {cancelButton || t('btn_cancel')}
          </Button>
          {onRemoveItem && (
            <Button
              type='button'
              className={'btn-md-sm px-15 text-nowrap px-md-15 mx-8 btn-outline-primary col col-md-none'}
              disabled={isButtonDisabled}
              onClick={onRemoveItem}
            >
              {isButtonDisabled && showLoadingButton && (
                <div className='spinner-border spinner-border-sm mr-4' role='status' />
              )}
              {t('btn_remove')}
            </Button>
          )}
          {onSubmit && (
            <Button
              type='submit'
              className={'btn-md-sm px-15 text-nowrap px-md-15 mx-8 mt-8 mt-md-0 w-100 w-md-none btn-primary'}
              disabled={isButtonDisabled}
            >
              {isButtonDisabled && showLoadingButton && (
                <div className='spinner-border spinner-border-sm mr-4' role='status' />
              )}
              {sumbitButton || t('btn_save')}
            </Button>
          )}
        </div>
      </form>
    </Modal>
  );
};

export default ManageModal;
